import React from 'react';
import { Icon } from '../';
import { Notification } from '../../../models/product/Notifications';
import { ProductWithBundleId } from '~/models/CampaignModel';

import './product-notification.scss';
import { validateProductConditions } from '~/store/basket/conditions';
interface ReduxProps {
  notification: Notification;
}
interface Props extends ReduxProps {
  selectedProducts: ProductWithBundleId[];
}

// TODO: add e2e tests for ProductNotification
export const ProductNotification: React.FC<Props> = ({ notification, selectedProducts }) => {
  return validateProductConditions(selectedProducts, notification) ? (
    <div className="product-notification">
      <Icon type="informationCircle" fill="#195A89" size={2} />
      <div>{notification?.title}</div>
    </div>
  ) : null;
};
